import React, { useEffect, useState }  from 'react';
import { Modal, Form } from 'react-bootstrap';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import { capitalize } from './utils';


const ModalFile = ({ cols, data, onSaveClickAction, showModal, setShowModal }) => {

    const [options, setOptions] = useState([]);
    const [attributes, setAttributes] = useState([]);

    const colsWithAccessor = cols.filter(item => item.accessor !== undefined && item.accessor !== null);
    const ord = colsWithAccessor.map(item => item.accessor);

    useEffect(()=>{
        if (data.length > 0){
            var optFromHeader = Object.keys(data[0]);

            // try to map the options and the attributes
            const optFromHeaderLowerCase = optFromHeader.map(item => item.toLocaleLowerCase());

            const newArr = colsWithAccessor.map((item, index) =>  {
                const matchIndex = optFromHeaderLowerCase.indexOf(item.Header.toLowerCase());
                return matchIndex < 0 ? 
                {attribute: item.accessor, mapped: optFromHeaderLowerCase[0]} : 
                {attribute: item.accessor, mapped: optFromHeaderLowerCase[matchIndex]}}
            ).filter(item => item !== null);

            setAttributes(newArr);

            optFromHeader.push('');
            setOptions(optFromHeader);

        }
    }, [data]);

    return(
        <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Select columns</Modal.Title> 

            <OverlayTrigger placement="bottom" overlay={ <Tooltip id="test">When uploading test data, leave the fields prefilled as-is.</Tooltip>}>
            <div className='icon-container'><InfoIcon className='switch-view'></InfoIcon></div>
            </OverlayTrigger>

        </Modal.Header>
        <Modal.Body>
            <Form>
            {
                attributes.length > 0 && colsWithAccessor.map((item, key) => {
                    return (
                        <Form.Group key={key} className="mb-3" controlId="formName">
                            {
                                item.accessor ? <>
                                <Form.Label key={`${key}-label`}>{capitalize(item.accessor)}</Form.Label>
                                <Form.Select key={`${key}-select`} onChange={(e) => {
                                    
                                    const arr = [...attributes.filter(element => 
                                        element.attribute !== item.accessor), 
                                        {attribute: item.accessor, mapped: e.target.value}];
                                    
                                    const reordered = ord.map(name => arr.find(item => item.attribute === name));
                                    setAttributes(reordered);

                                }} aria-label="select-cols">
                                {
                                    options.map((opt, index) => {
                                        return <option key={`option-${index}`} 
                                        selected={opt === attributes[key].mapped}
                                        value={opt}
                                        >{opt}</option>
                                    })
                                }
                                </Form.Select>
                                </> : null
                            }
                        </Form.Group>
                    )
                })
            }
            </Form>
        {/* <Form.Text><b>NOTE:</b> If you are uploading test data, leave the fields prefilled as-is. </Form.Text>  */}

        </Modal.Body>
        <Modal.Footer>
            <div className='btn-container btn-group-custom flex-row-center'>
            <button className="btn-custom blue" onClick={() => {
                setAttributes([]);
                setShowModal(false);
            }}>Cancel</button>
            <button className="btn-custom green" onClick={() => {
                onSaveClickAction(attributes);
                setAttributes([]);
                setShowModal(false);
            }}>Save</button>
            </div>
        </Modal.Footer>
        </Modal>

    )
}


export default ModalFile;
